var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-50 -296)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(50 296)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.161,10.827a5.554,5.554,0,0,1-3.348-.431,7.237,7.237,0,0,0-4.335-.484,7.673,7.673,0,0,0-3.846,2.414l-.1-.479L2.062,5.057A5.774,5.774,0,0,1,5.638,2.375c1.494-.3,2.773.689,4.256,1.832,1.436,1.108,3.064,2.36,5.061,2.275a8.412,8.412,0,0,0,4.738-2.236C19.1,7.381,17.619,10.241,15.161,10.827ZM21.2.139a.993.993,0,0,0-1.125.619c-.269.671-2.915,3.537-5.208,3.639-1.29.06-2.5-.878-3.787-1.868C9.458,1.276,7.617-.145,5.263.325A7.988,7.988,0,0,0,.109,4.411a1.084,1.084,0,0,0-.084.7l1.006,4.66h0L3.951,23.3a1.011,1.011,0,0,0,.975.815.959.959,0,0,0,.221-.026A1.045,1.045,0,0,0,5.9,22.845L4.2,14.943a6.565,6.565,0,0,1,3.727-3,5.439,5.439,0,0,1,3.257.429,7.359,7.359,0,0,0,4.426.486c3.759-.9,6.328-5.594,6.393-11.689A1.034,1.034,0,0,0,21.2.139Z",
    transform: "translate(54 298.882)",
    fill: "#006",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.4f9474672e526a7820a7fddde913655a.svg";
export { ForwardRef as ReactComponent };